import { Control, Controller } from 'react-hook-form';
import { FileInput } from '@/components';

interface FormFileInputProps {
  control: Control<any>;
  name: string;
  accept?: string;
  placeholder?: string;
  dropLabel?: string;
}

const FormFileInput = ({
  control,
  name,
  accept,
  placeholder,
  dropLabel,
}: FormFileInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FileInput
          value={value}
          onChange={onChange}
          accept={accept}
          placeholder={placeholder}
          dropLabel={dropLabel}
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
};

export default FormFileInput;
